var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{class:("main-circle " + _vm.mainCls)},[_c('div',{class:("out-layer-circle " + _vm.outCls)},[_c('div',{class:("inset-layer-circle " + _vm.insetCls)},[_c('div',{class:("inner-circle " + _vm.innerCls)})])])])}
var staticRenderFns = []

export { render, staticRenderFns }